import { Constructor, Nullable } from "../../Extensions";
import { NAMESPACE } from "./_Namespace";
import { Class } from "./System/Class";

const
    types = new Map<RegExp | string, () => Promise<Constructor<Class>>>();

export class DotNetTypeMapper
{
    public static classNamespace = NAMESPACE + "DotNetTypeMapper";
    public static className = "DotNetTypeMapper";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static add<T extends Class>(typeIdRegex: RegExp | string, createFn: () => Promise<Constructor<T>>): void
    {
        types.set(typeIdRegex, createFn);
    }

    public static addTypes<T extends Class>(types: { typeIdRegex: RegExp | string, createFn: () => Promise<Constructor<T>> }[])
    {
        types.forEach(item => this.add(item.typeIdRegex, item.createFn));
    }

    public static async createOptionalAsync<T extends Class>(typeId: string, propertyValues?: any): Promise<Nullable<T>>
    {
        for (let [key, value] of types)
        {
            if (!((typeof key === "string" && key === typeId) || (key instanceof RegExp && key.test(typeId))))
                continue;

            const
                classConstructor = await value();

            return new classConstructor(propertyValues) as T;
        }

        return null;
    }

    public static async createRequiredAsync<T extends Class>(typeId: string, propertyValues?: any): Promise<T>
    {
        const
            instance = await this.createOptionalAsync<T>(typeId, propertyValues);

        if (!instance)
            throw new Error(`Type \"${typeId}\" not found`);

        return instance;
    }
}